module.exports = __webpack_public_path__ + "assets/radius.a0b0e3b7.svg";